import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Case } from 'dashboard/models/case';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiOptions } from 'lib/clients/ApiClient';
import { ApiEndpoint, ApiListResponse, PaginationParams } from 'lib/interfaces/api';

export const caseApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    listCases: builder.query<ApiListResponse<Case>, ApiOptions>({
      query: async (options) =>
        SessionClientDashboard.listResource<Case, PaginationParams>(ApiEndpoint.Case, options),
    }),
  }),
});

export const { useListCasesQuery } = caseApi;
